<template>
  <div class="cadastro-de-aporte">
    <div class="column">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <div class="container container_com-fundo container_com-margem">
        <section>
          <main class="conteudo-principal columns">
            <h2 class="titulo titulo_grande">Preencha os campos abaixo para cadastrar o aporte.</h2>
            <h3 class="subtitle is-5" v-if="projeto != null">
              Adicione o valor do aporte para o projeto <strong>{{ this.projeto.Nome }}</strong>
            </h3>
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_2">
                <label class="formulario__label" for="valorDoAporte">Aporte</label>
                <input name="valorDoAporte" type="text" id="valorDoAporte" class="formulario__input"
                  placeholder="Insira o valor do aporte" v-model="aporte.Valor" v-mask="'money'" required />
              </div>
              <div class="grade__coluna grade__coluna_2">
                <label class="label" for="dataDoAporte">Data</label>
                <p class="control is-expanded">
                  <span>{{ $tempo.formatarParaPadraoBrasileiro(new Date()) }}</span>
                </p>
              </div>
            </div>
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_3">
                <router-link :to="{ name: 'ListaDeAportes', params: { projetoId: this.projeto.Id } }"
                  class="botao botao_medio botao_cinza" :class="{ 'is-disabled': loading.visivel }">Cancelar</router-link>
                <button type="button" class="botao botao_medio botao_cor-terciaria"
                  @click="gerenciarCadastroDoAporte">Salvar aporte</button>
              </div>
            </div>
          </main>
        </section>
      </div>
    </div>
    <modal v-if="modalDeConfirmacaoEstaVisivel" @close="fecharModalDeConfirmacao">
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlertaModal" />
      <form @submit.prevent="cadastrarAporte">
        <h3 class="titulo titulo_medio u-margem-inferior-media">Incluir aporte</h3>
        <div>
          <p class="mensagem-confirmacao">
            Após a confirmação da inclusão, não será possível edição ou exclusão.
            <hr>
            Incluir R$ {{ this.aporte.Valor }} no projeto <strong>{{ this.projeto.Nome }}</strong>
            <hr>
          </p>
        </div>
        <div class="grade__coluna u-sem-margem u-texto-alinhado-a-direita">
          <button type="button" @click="fecharModalDeConfirmacao" class="botao botao_cinza botao_medio">Cancelar</button>
          <button type="submit" class="botao botao_cor-terciaria botao_medio"
            :class="{ 'is-loading': loading.visivel }">Salvar</button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';
import Modal from '../shared/Modal';

export default {
  name: 'cadastrar-aporte',
  components: { Loading, Alerta, Modal },
  data() {
    return {
      aporte: {},
      projeto: {},
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
      modalDeConfirmacaoEstaVisivel: false,
      mensagemDeAlertaModal: null
    };
  },
  created() {
    let projetoId = this.$route.params.projetoId;
    if (projetoId)
      this.obterProjeto(projetoId);
  },
  directives: { mask: AwesomeMask },
  methods: {
    gerenciarCadastroDoAporte() {
      let aporte = JSON.parse(JSON.stringify(this.$data.aporte));
      let valorInvalido = Object.keys(aporte).length === 0 || this.$moeda.removerFormatacao(aporte.Valor) === 0;

      if (valorInvalido) {
        this.exibirMensagemDeErro("Verifique o campo preenchido e insira o valor do aporte corretamente");
        return;
      }

      this.abrirModalDeConfirmacao();
      this.mensagemDeAlerta = null;
    },
    cadastrarAporte() {
      let aporte = JSON.parse(JSON.stringify(this.$data.aporte));
      aporte.Valor = this.$moeda.removerFormatacao(aporte.Valor);
      aporte.ProjetoId = this.projeto.Id;

      this.exibirCarregamento();
      this.$api.post('/Projeto/Aportar', aporte).then(() => {
        this.redirecionarParaListagemDeAportes(this.projeto.Id);
      }).catch((error) => {
        this.tratarErro(error);
      });
    },
    obterProjeto(projetoId) {
      this.exibirCarregamento();
      let url = `/Projeto/${projetoId}`;
      this.$api.get(url).then((response) => {
        this.esconderCarregamento();
        this.projeto = response.data;

        if (!this.projeto)
          this.redirecionarParaListagemDeAportes();

        return response;
      }).catch((error) => {
        console.log(error)
        this.tratarErro(error);
      });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      let mensagensDeErro = error.response.data.Message;
      this.exibirMensagemDeErro(mensagensDeErro);
    },
    redirecionarParaListagemDeAportes(projetoId) {
      if (projetoId)
        this.$router.push({ name: 'ListaDeAportes', params: { projetoId: projetoId } })
      else
        this.$router.push({ name: 'ListaDeAportes' });
    },
    abrirModalDeConfirmacao() {
      this.modalDeConfirmacaoEstaVisivel = true;
    },
    fecharModalDeConfirmacao() {
      this.modalDeConfirmacaoEstaVisivel = false;
    },
    exibirMensagemDeErro(mensagem) {
      this.tipoDeAlerta = 'erro';
      this.mensagemDeAlerta = mensagem || 'Ocorreu um erro interno. Tente novamente ou contate o suporte';
    }
  }
};
</script>



// WEBPACK FOOTER //
// CadastroDeAporte.vue?05c34a8c